
import { CALL_FROM   } from '@/utils.js'
export default {
    methods:{
        selectURL_NextFrom_DoReportFile_ByCallFrmVar(res){
          // console.log('res---> ',res)
            let tmp_url =  "" 
            if(CALL_FROM == 0){  // 0 == labpatho.vet.ku.ac.th , 1 == local(172.16.2.116) , 2 == https://kuvdl.vet.ku.ac.th   
                tmp_url =  res.url
            }else if(CALL_FROM == 1){
                tmp_url =  res.url_private
            }else if(CALL_FROM == 2){
                tmp_url =  res.url_ssl
            }

            return tmp_url
        }
    },
 



}